import classNames from 'classnames';

import { Button } from './button';
import { ButtonProps } from './button.types';
import { BUTTON_VARIANT_M } from './config';

export const ButtonCritical = ({
  disabled,
  variant = BUTTON_VARIANT_M,
  children,
  className,
  ...props
}: ButtonProps) => {
  return (
    <Button
      disabled={disabled}
      {...props}
      className={classNames(className, {
        'text-critical-no-bg hover:text-critical-hover': !disabled,
        'text-critical-disabled': disabled,
      })}
      borderClasses='border border-critical-no-bg border-critical-no-bg'
      variant={variant}>
      {children}
    </Button>
  );
};
